export default function Home() {
  return (
    <div className="min-h-screen bg-[#000000] flex flex-col justify-center items-center p-6">
      {/* <div className="relative w-40 h-40 shadow-md">
        <div
          className="absolute inset-0 w-full h-full rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(50, 15, 133, 1) 0%, rgba(118, 60, 172, 1) 100%)",
          }}
        ></div>
        <img
          className="w-full h-full rounded-full absolute inset-0"
          src="/Ellipse.png"
          alt=""
        />
      </div> */}

      <h1 className="text-4xl md:text-5xl font-bold text-[#fff] text-center mb-4">
        Hi, I'm Arisrada Dhanabalan
      </h1>
      <p className="text-lg text-[#fff] text-center mb-6">
        Full-Stack Developer | React.js | Node.js | Express.js | MongoDB | SQL |
        React Native (Expo)
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <a
          href="/Arisrada_Resume.docx"
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
          download
        >
          Download Resume
        </a>
        <a
          href="https://github.com/arisrada"
          className="border border-blue-600 text-blue-600 px-6 py-2 rounded-lg hover:bg-blue-600 hover:text-white transition"
          target="_blank"
          rel="noreferrer"
        >
          Visit GitHub
        </a>
        <a
          href="https://linkedin.com/in/arisrada-d-26890b24a"
          className="border border-blue-600 text-blue-600 px-6 py-2 rounded-lg hover:bg-blue-600 hover:text-white transition"
          target="_blank"
          rel="noreferrer"
        >
          Visit LinkedIn
        </a>
      </div>
    </div>
  );
}
